import { useEffect, useState, useContext } from 'react';
import api from 'api';
import { get } from 'utils/fetch';
import { message, Spin, Input } from 'antd';
import { HoldingCompanyInsertion } from 'pages/RecordInsertion/HoldingCompanyInsertion';
import { GlobalContext } from 'GlobalContext';
import { isAdmin, isPhoneSize } from 'utils/util';

export function HoldingCompanyManager(props) {
    const {
        setManageRecordId,
        manageRecordId,
        accessToken,
        globalId,
        refreshSession,
    } = useContext(GlobalContext);
    const { filteredText, setFilteredText } = props;
    // const [filteredText, setFilteredText] = useState('');
    const [messageApi, contextHolder] = message.useMessage();
    const [loading, setLoading] = useState(true);
    const [holdingCompanies, setHoldingCompanies] = useState([]);
    const [properties, setProperties] = useState([]);
    const [holdingCompanyId, setHoldingCompanyId] = useState(0); // 0: main page

    const displayErrorMessage = (message) => {
        messageApi.open({
            type: 'error',
            content: message,
        });
    };

    async function fetchHoldingCompanies() {
        await get(
            api.manager.holdingCompanies + `?sale_id=${globalId}`,
            setHoldingCompanies,
            (errors) =>
                errors.forEach((err) => {
                    displayErrorMessage(err.message);
                }),
            accessToken
        );
        refreshSession();
        setLoading(false);
    }

    // async function fetchProperties() {
    //     await get(api.manager.properties, setProperties, (errors) =>
    //         errors.forEach(err => {
    //             displayErrorMessage(err.message);
    //         })
    //     )
    //     setLoading(false)
    // }

    useEffect(() => {
        if (manageRecordId !== 0) {
            setLoading(false);
        }
        // setFilteredText('');
        if (manageRecordId !== 0) return;
        fetchHoldingCompanies();
        // fetchProperties()
    }, [manageRecordId]);

    return (
        <>
            {loading && (
                <div style={{ marginTop: '30px', textAlign: 'center' }}>
                    <Spin />
                </div>
            )}
            {!loading && manageRecordId === 0 && (
                <>
                    <div
                        style={{
                            width: '300px',
                            marginTop: '30px',
                            marginLeft: '20px',
                            display: 'flex',
                            flexDirection: 'row',
                        }}
                    >
                        <Input
                            onChange={(e) => setFilteredText(e.target.value)}
                            value={filteredText}
                            placeholder="Filter on company name"
                        />
                        {filteredText && (
                            <div
                                onClick={() => setFilteredText('')}
                                style={{
                                    cursor: 'pointer',
                                    color: '#888',
                                    fontWeight: 'bold',
                                    fontSize: '16px',
                                    userSelect: 'none',
                                }}
                            >
                                ×
                            </div>
                        )}
                    </div>

                    {isAdmin() && (
                        <div style={{ margin: '20px' }}>
                            <button
                                style={{
                                    height: '30px',
                                    width: '50px',
                                    borderRadius: '30px',
                                    background: 'rgb(17 32 86)',
                                    color: 'white',
                                    cursor: 'pointer',
                                }}
                                onClick={() => setManageRecordId(-1)}
                            >
                                Add
                            </button>
                        </div>
                    )}
                    <div
                        style={
                            isPhoneSize()
                                ? { height: 'calc(100vh - 333px)' }
                                : { height: 'calc(100vh - 174px)' }
                        }
                    >
                        <div style={{ height: '100%', overflowY: 'scroll' }}>
                            {holdingCompanies
                                .filter(
                                    (holdingCompany) =>
                                        holdingCompany.name &&
                                        holdingCompany.name
                                            .toLowerCase()
                                            .includes(
                                                filteredText
                                                    .trim()
                                                    .toLowerCase()
                                            )
                                )
                                .sort((a, b) => {
                                    if (a.name < b.name) {
                                        return -1;
                                    }
                                    return 1;
                                })
                                .map((holdingCompany, idx) => {
                                    return (
                                        <div
                                            key={idx}
                                            style={{
                                                fontSize: '20px',
                                                margin: '20px',
                                                width: 'fit-content',
                                                color: 'blue',
                                                textDecoration: 'underline',
                                                cursor: 'pointer',
                                            }}
                                            onClick={() =>
                                                setManageRecordId(
                                                    holdingCompany.id
                                                )
                                            }
                                        >
                                            {`${holdingCompany.name}`}
                                        </div>
                                    );
                                })}
                        </div>
                    </div>
                </>
            )}
            {!loading && manageRecordId > 0 && (
                <>
                    <HoldingCompanyInsertion
                    // holdingCompany={holdingCompanies.filter(holdingCompany => holdingCompany.id === holdingCompanyId)[0]}
                    // setHoldingCompanyId={setHoldingCompanyId}
                    // properties={properties}
                    />
                </>
            )}
            {!loading && manageRecordId < 0 && (
                <>
                    <HoldingCompanyInsertion
                    // holdingCompany={null}
                    // setHoldingCompanyId={setHoldingCompanyId}
                    // properties={properties}
                    />
                </>
            )}
        </>
    );
}
